import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CartProvider } from "./contexts/CartContext";
import { initPerformanceOptimizations } from "./utils/performanceOptimizer";

// تهيئة تحسينات الأداء
initPerformanceOptimizations();

// Log successful React initialization
console.log("React app initialized successfully");

// نقطة البداية للتطبيق
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
